import React from "react"
import { BrowserRouter } from "react-router-dom"
import { Router } from "./Router"
import { ThemeProvider } from "./providers/ThemeProvider"
import { AlertProvider } from "@cd2/components"
import { FileboyProvider } from "@cd2/fileboy-react"
import { ApiProvider } from "./providers/ApiProvider"
import { Elements as StripeElements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { Global, css } from "@emotion/core"
import { useSiteAlerts } from "./hooks/useSiteAlerts"
import { listenForCompanySwitch } from "./interfaceParts/CompanySwitcher"

const stripe = loadStripe(process.env.STRIPE_PUBLIC_KEY!, { apiVersion: "2020-08-27" })

listenForCompanySwitch()

export function AppPack() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <Global
          styles={css`
            .tippy-box[data-animation="scale"][data-placement^="top"] {
              transform-origin: bottom;
            }
            .tippy-box[data-animation="scale"][data-placement^="bottom"] {
              transform-origin: top;
            }
            .tippy-box[data-animation="scale"][data-placement^="left"] {
              transform-origin: right;
            }
            .tippy-box[data-animation="scale"][data-placement^="right"] {
              transform-origin: left;
            }
            .tippy-box[data-animation="scale"][data-state="hidden"] {
              transform: scale(0.5);
              opacity: 0;
            }
          `}
        />
        <FileboyProvider
          publicKey={process.env.FILEBOY_PUBLIC_KEY || ""}
          // apiUrl="http://localhost:7031"
        >
          <AlertProvider>
            <AddSiteAlertsToWindow />
            <ApiProvider>
              <StripeElements stripe={stripe}>
                <React.Suspense fallback={<div />}>
                  <Router />
                </React.Suspense>
              </StripeElements>
            </ApiProvider>
          </AlertProvider>
        </FileboyProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

declare global {
  interface Window {
    siteAlerts: ReturnType<typeof useSiteAlerts>
  }
}
function AddSiteAlertsToWindow() {
  window.siteAlerts = useSiteAlerts()
  return null
}
